import { Controller } from "stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["primaryModal"]

  connect() {
    let secondaryModalElement = document.getElementById(this.primaryModalTarget.dataset.secondaryModal)
    this.secondaryModal = Modal.getOrCreateInstance(secondaryModalElement)
  }

  showSecondaryModal(e) {
    this.secondaryModal.show()
  }
}
